import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SplitPathQuestionItemState {
  selectedIndex?: number;
  isConfirmed: boolean;
  showValidationError: boolean;
}

export type SplitPathQuestionSliceState = Record<
  string,
  SplitPathQuestionItemState
>;

const getDefaultState = (): SplitPathQuestionItemState => ({
  isConfirmed: false,
  showValidationError: false,
});

const splitPathQuestionSlice = createSlice({
  name: "splitPathQuestion",
  initialState: {} as SplitPathQuestionSliceState,
  reducers: {
    selectOption: (
      state,
      action: PayloadAction<{ componentID: string; optionIndex: number }>
    ) => {
      const { componentID, optionIndex } = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      state[componentID].selectedIndex = optionIndex;
      state[componentID].showValidationError = false;
    },
    confirm: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      if (state[componentID].selectedIndex === undefined) {
        state[componentID].showValidationError = true;
      } else {
        state[componentID].isConfirmed = true;
        state[componentID].showValidationError = false;
      }
    },
    reset: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      state[componentID] = getDefaultState();
    },
  },
});

export const splitPathQuestionActions = splitPathQuestionSlice.actions;
export const splitPathQuestionReducer = splitPathQuestionSlice.reducer;

export const selectSplitPathQuestionState = (
  state: { splitPathQuestion: SplitPathQuestionSliceState },
  componentId: string
) => state.splitPathQuestion?.[componentId] || getDefaultState();
